var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protocol"},[_c('portlet',{attrs:{"title":"سالون يازما ئۇچۇرىغا ئېرىشىش"},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('we-chat-news-info',{attrs:{"need-view":true,"auto-load":!!_vm.url},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }